import React, { useState, useEffect } from "react";
import api from "../../axios";
import { get_course_URL, get_book_URL, get_image } from "../../helper";
import { useNavigate } from "react-router-dom";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import "swiper/css/navigation";
import {
  AiFillFacebook,
  AiOutlineInstagram,
  AiFillYoutube,
} from "react-icons/ai";
import { Link } from "react-router-dom";
import { FaTiktok, FaPaperclip, FaLinkedin } from "react-icons/fa";
import { CiMail } from "react-icons/ci";
import "./home.css";
import logo from "../../assets/logo.png";
import { useData } from "../../DataContext"; // Import the context

const Home = () => {
  const phoneNumber = "+201027097226";
  const whatsappURL = `https://wa.me/${phoneNumber}`;

  // Use cached data from context
  const { cachedData, updateCachedData } = useData();
  const [courses, setCourses] = useState(cachedData.courses);
  const [books, setBooks] = useState(cachedData.books);
  const [faqs, setFaqs] = useState(cachedData.faqs);
  const [setting, setSetting] = useState(cachedData.setting);
  const [services, setServices] = useState(cachedData.services);
  const [events, setEvents] = useState(cachedData.events);
  const [collab, setCollab] = useState(cachedData.collab);
  const [isLoading, setIsLoading] = useState(!cachedData.lastFetched);

  // 👇 جديد
  const [firstLoad, setFirstLoad] = useState(true);

  // Cache expiration time (5 minutes)
  const CACHE_EXPIRY = 5 * 60 * 1000;

  useEffect(() => {
    const fetchData = async () => {
      const startTime = Date.now();

      try {
        const [
          settingResponse,
          faqsResponse,
          coursesResponse,
          servicesResponse,
          booksResponse,
          eventsResponse,
          collabResponse,
        ] = await Promise.all([
          api.get("/setting", { params: { populate: "*" } }),
          api.get("/faqs"),
          api.get("/courses", {
            params: {
              pagination: { pageSize: 50 },
              populate: [
                "instructors.image",
                "gallery.image",
                "gallery.images",
                "home_image",
                "sliders",
              ],
              locale: "en",
            },
          }),
          api.get("/services", { params: { populate: "*" } }),
          api.get("/play-books", { params: { populate: "*" } }),
          api.get("/events", { params: { populate: "*" } }),
          api.get("/collaborators", { params: { populate: "*" } }),
        ]);

        const newData = {
          courses: coursesResponse.data.data,
          books: booksResponse.data.data,
          faqs: faqsResponse.data.data,
          setting: settingResponse.data.data.attributes,
          services: servicesResponse.data.data,
          events: eventsResponse.data.data,
          collab: collabResponse.data.data,
        };

        setCourses(newData.courses);
        setBooks(newData.books);
        setFaqs(newData.faqs);
        setSetting(newData.setting);
        setServices(newData.services);
        setEvents(newData.events);
        setCollab(newData.collab);

        updateCachedData(newData);

        // حساب الوقت اللي فات
        const elapsed = Date.now() - startTime;
        const remaining = Math.max(5500 - elapsed, 0);

        // 🖼️ استنى الصور تخلص تحميل
        const waitForImages = () =>
          new Promise((resolve) => {
            const images = Array.from(document.images);
            let loadedCount = 0;

            if (images.length === 0) return resolve();

            images.forEach((img) => {
              if (img.complete) {
                loadedCount++;
                if (loadedCount === images.length) resolve();
              } else {
                img.addEventListener("load", () => {
                  loadedCount++;
                  if (loadedCount === images.length) resolve();
                });
                img.addEventListener("error", () => {
                  loadedCount++;
                  if (loadedCount === images.length) resolve();
                });
              }
            });
          });

        setTimeout(async () => {
          await waitForImages();
          setIsLoading(false);
          setFirstLoad(false); // بعد أول تحميل
        }, remaining);
      } catch (error) {
        console.error("Error fetching data:", error);
        setIsLoading(false);
        setFirstLoad(false);
      }
    };

    fetchData();
  }, []);

  const navigate = useNavigate();
  const handleCourseClick = (course) => {
    navigate("courses/" + get_course_URL(course));
  };
  const handleBookClick = (book) => {
    navigate("play-books/" + get_book_URL(book));
  };
  const handleEventClick = (event) => {
    navigate("events/" + get_book_URL(event));
  };
  const handleServiceClick = (service) => {
    navigate("services/" + get_book_URL(service));
  };
  const handleCollabClick = (collab) => {
    navigate("collaborators/" + get_book_URL(collab));
  };

  const [placeholder, setPlaceholder] = useState("Attach files");

  const handleFileChange = (event) => {
    const fileInput = event.target;
    const fileName = fileInput.files[0].name;
    setPlaceholder(fileName);
  };

  if (isLoading) {
    return (
      <div className="loader-container">
        <img className="loader-image" src={logo} alt="Loading..." />
      </div>
    );
  }

  return (
    <>
      <section>
        <div className="home-cover">
          <img
            src={get_image(setting.wallpaper_top, "large")}
            srcSet={`
              ${get_image(setting.wallpaper_top, "small")} 480w,
              ${get_image(setting.wallpaper_top, "medium")} 800w,
              ${get_image(setting.wallpaper_top, "large")} 1200w
            `}
            sizes="(max-width: 600px) 480px, (max-width: 900px) 800px, 1200px"
            loading={firstLoad ? "eager" : "lazy"}
            alt={"cover"}
          />
        </div>
        <div className="home-container">
         <div id="programms">
  <div className="courses">
    {[...courses]
      .sort((a, b) => a.attributes.rank - b.attributes.rank) // ترتيب تصاعدي
      .map((course, index) => (
        <Link key={index} to={`/courses/${get_course_URL(course)}`} className="card">
          <img
            src={get_image(course.attributes.home_image, "large")}
            srcSet={`
              ${get_image(course.attributes.home_image, "small")} 480w,
              ${get_image(course.attributes.home_image, "medium")} 800w,
              ${get_image(course.attributes.home_image, "large")} 1200w
            `}
            sizes="(max-width: 600px) 480px, (max-width: 900px) 800px, 1200px"
            loading={firstLoad ? "eager" : "lazy"}
            alt={course?.attributes?.title || course.name}
          />
        </Link>
      ))}
  </div>
</div>


          <div id="books">
            <div className="courses">
              {books.map((book, index) => (
                <Link
                  key={index}
                  to={`/play-books/${get_book_URL(book)}`}
                  className="card"
                >
                  <img
                    src={get_image(book.attributes.home_image)}
                    alt={book.name}
                    loading={firstLoad ? "eager" : "lazy"}
                  />
                </Link>
              ))}
            </div>
          </div>

          <div id="services">
            <div className="courses">
              {services.map((service, index) => (
                <Link
                  key={index}
                  to={`/services/${get_book_URL(service)}`}
                  className="card"
                >
                  <img
                    src={get_image(service.attributes.home_image)}
                    alt={service.name}
                    loading={firstLoad ? "eager" : "lazy"}
                  />
                </Link>
              ))}
            </div>
          </div>

          <div id="events">
            <div className="courses">
              {events.map((event, index) => (
                <Link
                  key={index}
                  to={`/events/${get_book_URL(event)}`}
                  className="card"
                >
                  <img
                    src={get_image(event.attributes.home_image)}
                    alt={event.name}
                    loading={firstLoad ? "eager" : "lazy"}
                  />
                </Link>
              ))}
            </div>
          </div>

          <div id="collaborators">
            <div className="courses">
              {collab.map((colab, index) => (
                <Link
                  key={index}
                  to={`/collaborators/${get_book_URL(colab)}`}
                  className="card"
                >
                  <img
                    src={get_image(colab.attributes.home_image)}
                    alt={colab.name}
                    loading={firstLoad ? "eager" : "lazy"}
                  />
                </Link>
              ))}
            </div>
          </div>

          <div className="home-content">
            <div className="faq">
              <h1 style={{ color: "black" }}>
                Frequently Asked Questions - FAQ
              </h1>
              <div className="faq-content">
                {faqs.map((faq) => (
                  <Accordion style={{ border: "none" }}>
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon style={{ color: "black" }} />}
                      style={{
                        padding: "0",
                        fontSize: "13px",
                        color: "black",
                        border: "none",
                      }}
                    >
                      <Typography
                        style={{
                          fontFamily: "Lexend",
                          border: "none",
                          padding: "5px",
                        }}
                      >
                        {faq?.attributes?.title}
                      </Typography>
                    </AccordionSummary>
                    <AccordionDetails
                      style={{
                        fontFamily: "Lexend",
                        color: "black",
                        border: "none",
                      }}
                    >
                      <Typography
                        style={{
                          fontFamily: "Lexend",
                          color: "black",
                          border: "none",
                        }}
                      >
                        {faq?.attributes?.description}
                      </Typography>
                    </AccordionDetails>
                  </Accordion>
                ))}
              </div>
            </div>
            <div className="touch">
              <h1 style={{ color: "black" }}>Get In Touch</h1>
              <input type="text" placeholder="Write your message here" />
              <div className="file">
                <div className="addFile">
                  <label htmlFor="file-input" className="file-input-label">
                    <FaPaperclip className="file-input-icon" />
                    {placeholder}
                  </label>
                  <input
                    id="file-input"
                    type="file"
                    accept=".jpg, .jpeg, .png, .pdf, .doc,.docx,.xml"
                    onChange={handleFileChange}
                  />
                </div>
                <div className="btn">
                  <button>Send</button>
                </div>
              </div>
            </div>
          </div>

          <div className="wrapper">
            <div className="social-icons">
              <a href={setting?.facebook_link} target="_blank" rel="noreferrer">
                <AiFillFacebook className="icon" size={35} color="black" />
              </a>
              <a
                href={setting?.instagram_link}
                target="_blank"
                rel="noreferrer"
              >
                <AiOutlineInstagram className="icon" size={35} color="black" />
              </a>
              <a href={setting?.tiktok_link} target="_blank" rel="noreferrer">
                <FaTiktok className="icon" size={30} color="black" />
              </a>
              <a href={setting?.linkedin_link} target="_blank" rel="noreferrer">
                <FaLinkedin className="icon" size={30} color="black" />
              </a>
              <a href={setting?.youtube_link} target="_blank" rel="noreferrer">
                <AiFillYoutube className="icon" size={35} color="black" />
              </a>
              <a
                href="mailto:info@sae-grad.com"
                target="_blank"
                rel="noreferrer"
              >
                <CiMail className="icon" size={35} color="black" />
              </a>
            </div>
          </div>
        </div>
        <div className="home-cover2">
          <img
            src={get_image(setting.wallpaper_bottom, "large")}
            srcSet={`
              ${get_image(setting.wallpaper_bottom, "small")} 480w,
              ${get_image(setting.wallpaper_bottom, "medium")} 800w,
              ${get_image(setting.wallpaper_bottom, "large")} 1200w
            `}
            sizes="(max-width: 600px) 480px, (max-width: 900px) 800px, 1200px"
            loading={firstLoad ? "eager" : "lazy"}
            alt={"cover"}
          />
        </div>
      </section>
    </>
  );
};

export default Home;
